export class Receptor {
  static async send(data) {
    const response = await fetch("https://receptor.novaescola.org.br/", {
      method: "POST",
      headers: { "content-type": "text/plain" },
      body: JSON.stringify(data),
    });

    if (response.status !== 200) {
      throw new Error(`Receptor returned ${response.status}`);
    }
  }
}
